import styled, { css } from 'styled-components'
import media from 'styled-media-query'
import theme from '../../../../styles/theme'

export const Wrapper = styled.div`
  width: 100%;
  height: calc(100vh - 152px);
  margin: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  max-width: 1284px;
`
export const ContentCard = styled.p`
  font-weight: 300;
  color: ${theme.colors.darkGray};
  margin-bottom: 30px;
`
export const ActionsCard = styled.div`
  position: absolute;
  right: 15px;
  top: 15px;
  span {
    display: flex;
    & > button {
      margin-right: 7px;
    }
  }
`
export const TabBox = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  ${({ theme }) => css`
    width: 100%;
    max-width: 1284px;
    height: auto;
    margin: 82px 8px 40px 90px;

    border-radius: ${theme.border.radius};

    ${media.lessThan('huge')`
      max-width: 87%;
    `}

    ${media.lessThan('medium')`
      max-width: 580px;
    `}

    @media print {
      margin: 0 !important;
      max-width: none;
    }
  `}
`
export const TabItem = styled.div`
  background-color: #fff;
  max-width: 33%;
  width: 100%;
  border-radius: 16px;
  border: 1px solid ${theme.colors.primary};
  color: ${theme.colors.primary};
  height: 70px;
  display: flex;
  align-items: center;
  font-size: 1.4rem;
  padding: 0 30px;
  font-weight: 500;
  opacity: 0.8;
  position: relative;
  &.selected {
    opacity: 1;
    border-right: 6px solid ${theme.colors.primary};
  }
`
